export const isOutstandingDocumentRequirement = (requirement: {
  is_fulfilled: boolean;
}) => !requirement.is_fulfilled;
